var _defs, _rect, _g, _g2, _g3, _circle, _circle2, _path, _g4, _circle3, _g5, _g6, _g7, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1502.96 991.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #263238;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-4 {\n        stroke-width: 2px;\n      }\n\n      .cls-6 {\n        fill: #3a384d;\n      }\n\n      .cls-2, .cls-7, .cls-3, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke: #231f20;\n      }\n\n      .cls-8 {\n        fill: #9bd6e8;\n      }\n\n      .cls-9 {\n        fill: #80b3ff;\n      }\n\n      .cls-10 {\n        fill: #bdccd4;\n      }\n\n      .cls-11 {\n        fill: #2e2d3d;\n      }\n\n      .cls-3, .cls-5 {\n        stroke-width: .75px;\n      }\n\n      .cls-12 {\n        fill: #d5e1e8;\n      }\n\n      .cls-13 {\n        fill: #ff9b64;\n      }\n\n      .cls-14, .cls-4, .cls-15 {\n        fill: #ff6500;\n      }\n\n      .cls-16 {\n        fill: #f09959;\n      }\n\n      .cls-15 {\n        opacity: .14;\n      }\n\n      .cls-17 {\n        fill: #e38540;\n      }\n\n      .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-18 {\n        opacity: .69;\n      }\n\n      .cls-19 {\n        fill: #7a4e34;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 208.77,
    y: 174.7,
    width: 1098.83,
    height: 670.73,
    rx: 57.18,
    ry: 57.18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 727.28,
    cy: 174.7,
    r: 110.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 727.28,
    cy: 174.7,
    r: 97.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 727.28,
    cy: 174.7,
    r: 80.66
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 208.77,
    cy: 519.5,
    r: 110.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 208.77,
    cy: 519.5,
    r: 97.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 208.77,
    cy: 519.5,
    r: 80.66
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 726.57,
    cy: 845.43,
    r: 110.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 726.57,
    cy: 845.43,
    r: 97.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 726.57,
    cy: 845.43,
    r: 80.66
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 208.77,
    cy: 518.45,
    r: 66.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 726.57,
    cy: 845.43,
    r: 66.28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.4,483.27c1.02,1.13,2.37,1.91,3.85,2.23v6.41c0,.84.68,1.52,1.51,1.52.84,0,1.52-.68,1.52-1.51h0v-6.41c1.49-.32,2.84-1.1,3.85-2.23l23.48,13.55c-.51,1.58-.46,3.28.13,4.83l-5.51,3.09c-.73.41-.99,1.34-.57,2.07.27.47.77.77,1.32.77.26,0,.52-.07.74-.2l5.69-3.2c.98.98,2.22,1.65,3.58,1.94v27.12c-1.51.33-2.88,1.13-3.91,2.29l-5.59-3.14c-.73-.41-1.65-.15-2.06.57s-.15,1.65.57,2.06l5.58,3.15c-.44,1.43-.43,2.95.03,4.37l-23.48,13.55c-1.02-1.13-2.37-1.91-3.85-2.23v-6.41c0-.84-.68-1.52-1.51-1.52-.84,0-1.52.68-1.52,1.51h0v6.41c-1.49.32-2.84,1.1-3.85,2.23l-23.48-13.55c.51-1.57.46-3.27-.13-4.81l5.51-3.1c.73-.42.98-1.34.56-2.07-.41-.72-1.32-.97-2.05-.57l-5.68,3.2c-.98-.98-2.23-1.66-3.59-1.95v-27.12c1.19-.26,2.3-.81,3.22-1.61l5.82,3.27c.23.13.48.2.74.2.84,0,1.52-.69,1.51-1.53,0-.55-.3-1.05-.77-1.32l-5.47-3.08c.76-1.65.87-3.52.31-5.25l23.48-13.55ZM168.82,499.05c0,2.32,1.88,4.21,4.2,4.21,2.32,0,4.21-1.88,4.21-4.2,0-2.32-1.88-4.21-4.2-4.21,0,0,0,0,0,0-2.32,0-4.2,1.88-4.21,4.2ZM208.77,474.21c2.33,0,4.21,1.88,4.21,4.21,0,2.33-1.88,4.21-4.21,4.21-2.33,0-4.21-1.88-4.21-4.21h0c0-2.32,1.89-4.21,4.21-4.21ZM244.51,494.85c-2.32,0-4.21,1.89-4.2,4.21,0,2.32,1.89,4.21,4.21,4.2,2.32,0,4.21-1.89,4.2-4.21h0c0-2.32-1.89-4.2-4.21-4.2ZM248.72,540.33c0-2.32-1.88-4.21-4.2-4.21-2.32,0-4.21,1.88-4.21,4.2,0,2.32,1.88,4.21,4.2,4.21,0,0,0,0,0,0,2.32,0,4.2-1.88,4.21-4.2ZM208.77,565.17c-2.33,0-4.21-1.88-4.21-4.21,0-2.33,1.88-4.21,4.21-4.21,2.33,0,4.21,1.88,4.21,4.21h0c0,2.32-1.89,4.21-4.21,4.21ZM173.03,544.53c2.32,0,4.21-1.88,4.2-4.21,0-2.32-1.88-4.21-4.21-4.2-2.32,0-4.21,1.88-4.2,4.21h0c0,2.32,1.89,4.2,4.21,4.2ZM208.77,541.17c11.86-.01,21.47-9.62,21.48-21.48,0-11.84-9.64-21.47-21.48-21.47s-21.48,9.64-21.48,21.47c.01,11.86,9.62,21.47,21.48,21.48h0ZM198.74,535.16c6.1,3.97,13.97,3.97,20.07,0l-.02-5.32c-.52-1.05-1.55-1.79-3.14-2.28-.93-.25-1.73-.47-2.39-.67l-3.17,5.49c-.42.73-1.34.98-2.07.56-.23-.13-.42-.33-.56-.56l-3.17-5.49c-.66.2-1.45.42-2.39.67-1.59.49-2.62,1.23-3.14,2.28l-.02,5.32ZM208.77,501.24c-10.18,0-18.44,8.24-18.45,18.43,0,4.89,1.94,9.58,5.39,13.04l.02-3.2c0-.19.04-.38.11-.56.83-2.06,2.58-3.5,5.2-4.29.01,0,.03-.01.05,0,1.53-.42,2.66-.75,3.47-1,.68-.21,1.4.08,1.75.7l2.45,4.25,2.45-4.25c.35-.61,1.08-.9,1.75-.7.81.25,1.94.58,3.48,1,.02,0,.03,0,.05,0,2.62.8,4.37,2.24,5.2,4.29.07.18.11.37.11.56l.02,3.2c7.2-7.2,7.19-18.88,0-26.07-3.46-3.46-8.15-5.4-13.05-5.4h0ZM208.91,522.53c3.73,0,6.76-3.03,6.76-6.76,0-3.73-3.03-6.76-6.76-6.76-3.73,0-6.76,3.03-6.76,6.76h0c0,3.73,3.03,6.76,6.76,6.76ZM208.91,512.04c-2.06,0-3.73,1.67-3.73,3.73,0,2.06,1.67,3.73,3.73,3.73,2.06,0,3.73-1.67,3.73-3.73h0c0-2.06-1.67-3.73-3.73-3.73Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1307.6,
    cy: 519.5,
    r: 110.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1307.6,
    cy: 519.5,
    r: 97.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 1307.6,
    cy: 519.5,
    r: 80.66
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1307.61,
    cy: 518.45,
    r: 66.28
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_46---Floating-Bot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-3",
    d: "M750.12,878.84c1.63,0,2.94-1.32,2.94-2.94v-11.78c0-3.5-2.46-6.51-5.89-7.21v18.99c0,1.63,1.32,2.94,2.94,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-3",
    d: "M738.34,880.31c3.25,0,5.89-2.64,5.89-5.89v-14.06c-2.4.75-4.87,1.29-7.36,1.62v18.33h1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-3",
    d: "M726.56,862.64c-2.77,0-5.2-.13-7.36-.33v18h14.72v-18c-2.16.2-4.6.33-7.36.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-3",
    d: "M720.67,889.14h11.78c2.44,0,4.42-1.98,4.42-4.42v-1.47h-20.61v1.47c0,2.44,1.98,4.42,4.42,4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-3",
    d: "M747.18,840.56v-.04c-1.27.97-2.82,1.51-4.42,1.51h-32.39c-1.6,0-3.15-.54-4.42-1.51v.04c0,4.06,3.3,7.36,7.36,7.36h26.5c4.06,0,7.36-3.3,7.36-7.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    className: "cls-3",
    d: "M716.26,861.98c-2.5-.33-4.96-.87-7.36-1.62v14.07c0,3.25,2.64,5.89,5.89,5.89h1.47v-18.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    className: "cls-3",
    d: "M744.23,856.76c0-3.25-2.64-5.89-5.89-5.89h-23.56c-3.25,0-5.89,2.64-5.89,5.89v.49c1.98.74,7.68,2.46,17.67,2.46s15.68-1.72,17.67-2.46v-.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-3",
    cx: 714.79,
    cy: 830.26,
    r: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    className: "cls-3",
    d: "M705.95,819.95v.04c1.27-.97,2.82-1.51,4.42-1.51h32.39c1.6,0,3.15.54,4.42,1.51v-.04c0-7.31-5.94-13.24-13.25-13.25h-14.72c-7.31,0-13.24,5.94-13.25,13.25h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    className: "cls-3",
    cx: 738.34,
    cy: 830.26,
    r: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    className: "cls-3",
    d: "M700.06,864.12v11.78c0,1.63,1.32,2.94,2.94,2.94s2.94-1.32,2.94-2.94v-18.99c-3.43.7-5.89,3.72-5.89,7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    className: "cls-3",
    d: "M705.95,834.67c0,2.44,1.98,4.42,4.42,4.42h32.39c2.44,0,4.42-1.98,4.42-4.42v-8.83c0-2.44-1.98-4.42-4.42-4.42h-32.39c-2.44,0-4.42,1.98-4.42,4.42v8.83ZM738.34,824.37c3.25,0,5.89,2.64,5.89,5.89s-2.64,5.89-5.89,5.89-5.89-2.64-5.89-5.89,2.64-5.89,5.89-5.89ZM714.79,824.37c3.25,0,5.89,2.64,5.89,5.89s-2.64,5.89-5.89,5.89-5.89-2.64-5.89-5.89,2.64-5.89,5.89-5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    className: "cls-3",
    d: "M689.76,834.67c1.86,0,3.52-1.19,4.15-2.94h4.69c0,2.68,1.82,5.03,4.42,5.7v-14.35c-2.6.67-4.41,3.02-4.42,5.7h-4.69c-.75-2.11-2.97-3.32-5.15-2.81-2.18.51-3.64,2.57-3.38,4.8.26,2.23,2.15,3.91,4.39,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    className: "cls-3",
    d: "M759.22,828.78h-4.69c0-2.68-1.82-5.03-4.42-5.7v14.35c2.6-.67,4.41-3.02,4.42-5.7h4.69c.72,2.03,2.79,3.24,4.91,2.88,2.12-.36,3.67-2.2,3.67-4.35s-1.55-3.99-3.67-4.35c-2.12-.36-4.19.85-4.91,2.88h0Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 727.28,
    cy: 174.7,
    r: 66.28
  }), /*#__PURE__*/React.createElement("g", {
    id: "workflow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M742.05,135.3h-29.55c-2.72,0-4.92,2.21-4.93,4.93v9.85c0,2.72,2.21,4.92,4.93,4.93h29.55c2.72,0,4.92-2.21,4.93-4.93v-9.85c0-2.72-2.21-4.92-4.93-4.93ZM732.2,147.61h-9.85c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h9.85c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M742.05,164.85h-29.55c-2.72,0-4.92,2.21-4.93,4.93v9.85c0,2.72,2.21,4.92,4.93,4.93h29.55c2.72,0,4.92-2.21,4.93-4.93v-9.85c0-2.72-2.21-4.92-4.93-4.93ZM732.2,177.17h-9.85c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h9.85c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M742.05,194.4h-29.55c-2.72,0-4.92,2.21-4.93,4.93v9.85c0,2.72,2.21,4.92,4.93,4.93h29.55c2.72,0,4.92-2.21,4.93-4.93v-9.85c0-2.72-2.21-4.92-4.93-4.93ZM732.2,206.72h-9.85c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h9.85c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M700.19,147.61h-9.85c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h9.85c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.72,152.54c-1.36,0-2.46-1.1-2.46-2.46,0-.65.26-1.28.72-1.74l3.19-3.2-3.21-3.25c-.97-.96-.97-2.52-.01-3.48.96-.97,2.52-.97,3.48-.01.01.01.02.02.04.04l4.93,4.99c.95.96.94,2.51-.01,3.47l-4.93,4.93c-.46.46-1.09.72-1.74.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M761.75,206.72h-9.85c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h9.85c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M759.29,211.64c-1.36,0-2.46-1.1-2.46-2.46,0-.65.26-1.28.72-1.74l3.19-3.2-3.21-3.25c-.97-.96-.98-2.51-.02-3.48.96-.97,2.51-.98,3.48-.02.02.02.03.03.05.05l4.93,4.99c.95.96.94,2.51-.01,3.47l-4.93,4.93c-.46.46-1.09.72-1.74.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M749.44,177.17h-4.93c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h4.93c6.8,0,12.31-5.51,12.31-12.31s-5.51-12.31-12.31-12.31h-4.93c-1.36,0-2.46-1.1-2.46-2.46s1.1-2.46,2.46-2.46h4.93c9.52,0,17.24,7.72,17.24,17.24s-7.72,17.24-17.24,17.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M710.04,206.72h-4.93c-9.52,0-17.24-7.72-17.24-17.24s7.72-17.24,17.24-17.24h4.93c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46h-4.93c-6.8,0-12.31,5.51-12.31,12.31s5.51,12.31,12.31,12.31h4.93c1.36,0,2.46,1.1,2.46,2.46s-1.1,2.46-2.46,2.46Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M971.74,366.31c.44-3.95.68-7.96.68-12.03,0-2.15-.07-4.27-.2-6.39l-19.87-6.43c-1.22-8.38-3.63-16.37-7.04-23.81l13.18-16.21c-3.05-5.36-6.54-10.44-10.44-15.17l-19.88,6.49c-5.79-5.92-12.41-11.02-19.68-15.12l1.13-20.88c-5.55-2.52-11.35-4.59-17.35-6.15l-12.27,16.94c-4.78-.81-9.7-1.23-14.71-1.23-3.42,0-6.79.2-10.1.58l-11.36-17.56c-6.09,1.24-11.99,2.99-17.65,5.22l.03,20.91c-7.48,3.72-14.36,8.47-20.45,14.07l-19.5-7.52c-4.14,4.53-7.9,9.41-11.23,14.6l12.3,16.89c-3.81,7.26-6.63,15.12-8.3,23.4l-20.18,5.37c-.44,3.95-.68,7.96-.68,12.03,0,2.15.07,4.27.2,6.39l19.87,6.43c1.22,8.38,3.63,16.37,7.04,23.81l-13.18,16.21c3.05,5.36,6.54,10.44,10.44,15.17l19.88-6.49c5.79,5.92,12.41,11.02,19.68,15.12l-1.13,20.88c5.55,2.53,11.35,4.59,17.35,6.15l12.27-16.94c4.78.81,9.7,1.23,14.71,1.23,3.42,0,6.79-.2,10.1-.58l11.36,17.56c6.09-1.24,11.99-2.99,17.65-5.22l-.03-20.91c7.48-3.72,14.36-8.47,20.45-14.07l19.5,7.52c4.14-4.53,7.91-9.41,11.23-14.6l-12.31-16.89c3.81-7.26,6.63-15.12,8.3-23.4l20.18-5.37ZM868.03,396.21c-25.36,1.6-46.26-19.3-44.66-44.66,1.32-20.91,18.29-37.88,39.2-39.2,25.35-1.6,46.26,19.3,44.66,44.66-1.32,20.91-18.29,37.88-39.2,39.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M601.41,646.28c-.45,0-.9-.16-1.26-.5-5.68-5.34-12.25-9.4-19.54-12.04-.95-.34-1.44-1.4-1.1-2.35.34-.95,1.4-1.44,2.35-1.1,7.76,2.82,14.76,7.13,20.8,12.82.74.69.77,1.85.08,2.59-.36.38-.85.58-1.33.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M546.87,632.13c-.82,0-1.56-.55-1.77-1.38-.25-.98.35-1.98,1.33-2.22,4.82-1.22,9.81-1.83,14.83-1.83,1.01,0,1.83.82,1.83,1.83s-.82,1.83-1.83,1.83c-4.72,0-9.41.58-13.94,1.72-.15.04-.3.06-.45.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1043.21,686.12c0-.95-.03-1.89-.08-2.82l12.03-9.66c-.94-4.82-2.42-9.45-4.37-13.82l-15.53-1.17c-3.53-5.57-8.1-10.42-13.44-14.27l-.05-15.48c-4.33-2.27-8.94-4.07-13.77-5.31l-10.61,11.42c-1.83-.2-3.69-.3-5.57-.3-4.68,0-9.21.63-13.51,1.8l-12.17-9.64c-4.59,2-8.91,4.51-12.87,7.47l2.3,15.34c-4.54,4.52-8.24,9.88-10.84,15.82l-15.14,3.51c-1.28,4.68-2.05,9.56-2.24,14.6l13.34,7.71c.68,6.75,2.67,13.12,5.7,18.85l-6.68,13.99c2.86,3.92,6.16,7.5,9.81,10.68l14.3-5.6c5.62,3.66,12,6.25,18.86,7.48l6.74,13.88c.8.03,1.61.05,2.42.05,4.04,0,7.99-.37,11.83-1.08l4.55-14.7c6.62-2.22,12.64-5.76,17.75-10.3l15.03,3.38c3.08-3.62,5.77-7.58,8.01-11.83l-8.71-12.8c1.91-5.38,2.95-11.16,2.95-17.19ZM991.25,708.77c-11.96,0-21.65-9.69-21.65-21.65s9.69-21.65,21.65-21.65,21.65,9.69,21.65,21.65-9.69,21.65-21.65,21.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 950.09,
    y: 408.52,
    width: 169.1,
    height: 248.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 975.03,
    y: 438.06,
    width: 119.23,
    height: 116.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 975.03,
    y: 563.38,
    width: 119.23,
    height: 18.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.25,
    y: 592.62,
    width: 102.89,
    height: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 981.14,
    cy: 593.16,
    r: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.25,
    y: 609.68,
    width: 102.89,
    height: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 981.14,
    cy: 610.22,
    r: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.25,
    y: 626.74,
    width: 102.89,
    height: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 981.14,
    cy: 627.28,
    r: 4.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M989.2,465.12c0,23.03,13.87,60.19,46.58,59,32.71-1.19,39.95-36.61,41.21-46.61,1.27-10-87.79-12.39-87.79-12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M975.57,554.79c10.8-23.24,29.08-30.68,59.1-30.68,35.74,0,54.3,12.95,59.56,31.8-64.01.88-118.66-1.12-118.66-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1040.6,542.66c-3.42,5.05-5.93,5.26-9.65,0-2.95-4.18-8.77-13.69-8.77-18.51v-48.13c0-4.82,3.95-8.77,8.77-8.77h9.65c4.82,0,8.77,3.95,8.77,8.77v48.13c0,4.82-5.7,13.98-8.77,18.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1040.6,467.25h-9.65c-4.82,0-8.77,3.95-8.77,8.77v42.94c10.83,3.45,20.71-3.41,27.18-11.13v-31.81c0-4.82-3.95-8.77-8.77-8.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1035.78,
    cy: 467.74,
    rx: 29.15,
    ry: 39.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1051.8,437.55c-3.46,12.22-11.06,12.08-21.64,16.09-10.59,4.01-15.65,8.05-19.11,15.86-4.42,9.97,2.01,39.02,2.01,39.02,0,0-26.8-20.06-23.7-51.6,3.1-31.55,21.7-43.76,39.2-43.76s24.16,10.67,24.16,10.67c0,0,9.33.04,18.14,10.48,11.85,14.04,8.21,48.14,0,60.36-8.21,12.22-13.68,16.05-13.49,15.5.18-.55,7.66-28.6,3.65-45.95-4.01-17.35-9.21-26.66-9.21-26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1046.74,489.28s-4.91,6.36-10.96,6.36-10.96-6.36-10.96-6.36h21.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 375.53,
    y: 408.52,
    width: 169.1,
    height: 248.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 400.47,
    y: 438.06,
    width: 119.23,
    height: 116.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 400.47,
    y: 563.38,
    width: 119.23,
    height: 18.79
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 592.62,
    width: 102.89,
    height: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 406.58,
    cy: 593.16,
    r: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 609.68,
    width: 102.89,
    height: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 406.58,
    cy: 610.22,
    r: 4.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.69,
    y: 626.74,
    width: 102.89,
    height: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 406.58,
    cy: 627.28,
    r: 4.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M401.31,553.33c10.58-22.76,28.49-30.05,57.89-30.05,35.01,0,53.19,12.68,58.35,31.15-62.7.86-116.24-1.1-116.24-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M446.97,412.58c-14.82,4.16-14.17,12.49-19.11,20.22-4.94,7.73-15.68,12.88-16.96,18.04-1.29,5.15,3.31,15.89-2.15,21.9-5.45,6.01-7.3,9.02-5.15,15.03,2.15,6.01,6.87,15.46,7.3,16.75.43,1.29,6.44,10.31,13.74,11.6,7.3,1.29,21.04,3.44,27.91,6.44,6.87,3.01,28.96-3.85,41.23-3.42,12.26.43,20.61-8.61,19.75-14.62-.86-6.01,9.04-18.04,9.02-28.34-.03-11.07-12.88-19.33-16.32-26.63-3.44-7.3.43-20.18-12.45-27.82-8.14-4.82-13.74-4.39-20.18-6.54-6.44-2.15-17.18-5.26-26.63-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M465.01,541.45c-3.35,4.95-5.81,5.15-9.45,0-2.89-4.1-8.59-13.41-8.59-18.13v-47.15c0-4.72,3.87-8.59,8.59-8.59h9.45c4.72,0,8.59,3.87,8.59,8.59v47.15c0,4.72-5.58,13.69-8.59,18.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M465.01,467.58h-9.45c-4.72,0-8.59,3.87-8.59,8.59v42.07c10.61,3.38,20.29-3.34,26.63-10.9v-31.16c0-4.72-3.87-8.59-8.59-8.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 460.28,
    cy: 468.06,
    rx: 28.56,
    ry: 38.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M473.6,437.09c-18.04,30.49-44.66,27.49-44.66,27.49,0,0,.64-40.37,21.79-42.52,21.15-2.15,33.61,6.34,37.9,20.35,4.29,14.01,0,23.24,0,23.24,0,0-6.87-5.37-10.31-13.96-3.44-8.59-4.72-14.6-4.72-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M434.65,467.46c2.67,5.62,1.8,11.63-1.95,13.41-3.75,1.78-8.95-1.34-11.63-6.96-2.67-5.62-1.8-11.63,1.95-13.41,3.75-1.78,8.95,1.33,11.63,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M484.63,467.46c-2.67,5.62-1.8,11.63,1.95,13.41,3.75,1.78,8.95-1.34,11.63-6.96,2.67-5.62,1.8-11.63-1.95-13.41-3.75-1.78-8.95,1.33-11.63,6.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M471.02,489.17s-4.81,6.23-10.74,6.23-10.74-6.23-10.74-6.23h21.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 800,
    y: 375.99,
    width: 213.32,
    height: 313.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 831.45,
    y: 413.25,
    width: 150.41,
    height: 146.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 831.45,
    y: 571.35,
    width: 150.41,
    height: 23.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.91,
    y: 608.23,
    width: 129.79,
    height: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 839.17,
    cy: 608.92,
    r: 5.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.91,
    y: 629.76,
    width: 129.79,
    height: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 839.17,
    cy: 630.44,
    r: 5.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.91,
    y: 651.28,
    width: 129.79,
    height: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 839.17,
    cy: 651.96,
    r: 5.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M849.33,447.39c0,29.05,17.49,75.93,58.76,74.42,41.26-1.5,50.39-46.19,51.99-58.8,1.6-12.61-110.75-15.63-110.75-15.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M832.14,560.51c13.63-29.31,36.69-38.7,74.55-38.7,45.09,0,68.5,16.33,75.14,40.12-80.75,1.11-149.69-1.42-149.69-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M914.17,545.21c-4.32,6.37-7.48,6.64-12.17,0-3.73-5.28-11.06-17.27-11.06-23.35v-60.71c0-6.08,4.98-11.06,11.06-11.06h12.17c6.08,0,11.06,4.98,11.06,11.06v60.71c0,6.08-7.19,17.63-11.06,23.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M914.17,450.08h-12.17c-6.08,0-11.06,4.98-11.06,11.06v54.17c13.66,4.35,26.13-4.3,34.29-14.04v-40.13c0-6.08-4.98-11.06-11.06-11.06Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 908.09,
    cy: 450.7,
    rx: 36.78,
    ry: 50.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M928.3,412.61c-4.37,15.41-13.95,15.23-27.3,20.29-13.35,5.06-19.74,10.15-24.11,20.01-5.57,12.57,2.53,49.23,2.53,49.23,0,0-33.81-25.3-29.9-65.1,3.91-39.79,27.37-55.21,49.46-55.21s30.48,13.46,30.48,13.46c0,0,11.76.05,22.89,13.23,14.95,17.71,10.35,60.73,0,76.14-10.35,15.41-17.25,20.24-17.02,19.55.23-.69,9.66-36.08,4.6-57.97-5.06-21.88-11.62-33.64-11.62-33.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M921.91,477.88s-6.19,8.02-13.83,8.02-13.83-8.02-13.83-8.02h27.65Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 478.19,
    y: 375.99,
    width: 213.32,
    height: 313.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 509.64,
    y: 413.25,
    width: 150.41,
    height: 146.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 509.64,
    y: 571.35,
    width: 150.41,
    height: 23.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.1,
    y: 608.23,
    width: 129.79,
    height: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 517.36,
    cy: 608.92,
    r: 5.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.1,
    y: 629.76,
    width: 129.79,
    height: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 517.36,
    cy: 630.44,
    r: 5.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.1,
    y: 651.28,
    width: 129.79,
    height: 1.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 517.36,
    cy: 651.96,
    r: 5.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M510.7,558.67c13.35-28.71,35.94-37.91,73.03-37.91,44.17,0,67.1,16,73.61,39.3-79.1,1.08-146.64-1.39-146.64-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M568.31,381.11c-18.7,5.25-17.88,15.75-24.11,25.51-6.23,9.75-19.77,16.25-21.4,22.75-1.63,6.5,4.17,20.05-2.71,27.63-6.88,7.58-9.21,11.38-6.5,18.96,2.71,7.58,8.67,19.5,9.21,21.13.54,1.63,8.13,13,17.34,14.63,9.21,1.63,26.55,4.33,35.21,8.13,8.67,3.79,36.54-4.86,52.01-4.31,15.47.54,26-10.86,24.92-18.44-1.08-7.58,11.41-22.75,11.38-35.76-.03-13.96-16.25-24.38-20.59-33.59-4.33-9.21.54-25.46-15.71-35.09-10.27-6.08-17.34-5.54-25.46-8.25-8.13-2.71-21.67-6.64-33.59-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M591.06,543.69c-4.23,6.24-7.33,6.5-11.92,0-3.65-5.17-10.84-16.91-10.84-22.87v-59.48c0-5.96,4.88-10.84,10.84-10.84h11.92c5.96,0,10.84,4.88,10.84,10.84v59.48c0,5.96-7.04,17.27-10.84,22.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M591.06,450.5h-11.92c-5.96,0-10.84,4.88-10.84,10.84v53.07c13.38,4.26,25.6-4.21,33.59-13.75v-39.31c0-5.96-4.88-10.84-10.84-10.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 585.1,
    cy: 451.1,
    rx: 36.03,
    ry: 49.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M601.89,412.04c-22.75,38.47-56.34,34.67-56.34,34.67,0,0,.81-50.93,27.49-53.63,26.68-2.71,42.39,8,47.81,25.67,5.42,17.67,0,29.32,0,29.32,0,0-8.67-6.77-13-17.61-4.33-10.83-5.96-18.42-5.96-18.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M552.76,450.35c3.37,7.09,2.27,14.67-2.46,16.91-4.73,2.25-11.3-1.68-14.67-8.78-3.37-7.09-2.27-14.67,2.46-16.91,4.73-2.25,11.3,1.68,14.67,8.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M615.81,450.35c-3.37,7.09-2.27,14.67,2.46,16.91,4.73,2.25,11.3-1.68,14.67-8.78,3.37-7.09,2.27-14.67-2.46-16.91-4.73-2.25-11.3,1.68-14.67,8.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M598.64,477.73s-6.06,7.86-13.54,7.86-13.54-7.86-13.54-7.86h27.09Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 607.64,
    y: 328.48,
    width: 277.9,
    height: 408.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 648.61,
    y: 377.03,
    width: 195.94,
    height: 190.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 648.61,
    y: 582.99,
    width: 195.94,
    height: 30.88
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.27,
    y: 631.04,
    width: 169.08,
    height: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 658.66,
    cy: 631.93,
    r: 7.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.27,
    y: 659.08,
    width: 169.08,
    height: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 658.66,
    cy: 659.97,
    r: 7.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 675.27,
    y: 687.11,
    width: 169.08,
    height: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 658.66,
    cy: 688,
    r: 7.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M701.95,425.98c-.31-.93-8.08-45.54-9.01-62.89-.93-17.35,27.88-19.83,27.88-19.83,0,0,23.55-12.7,40.59-6.2,17.04,6.51,28.64,17.45,36.38,31.09,7.75,13.63-6.81,56.12-6.81,56.12l-89.03,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M648.53,569.33c-.11-.73,1.99-18.29,2.07-19,3.92-36.97,49.5-47.37,94.97-47.37,53.43,0,89.68,9.78,95.46,48.2.17,1.13,3.25,18.73,3.1,19.91-99.03,1.36-195.6-1.74-195.6-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M754.75,531.65c-5.29,7.82-9.18,8.14-14.92,0-4.57-6.47-19.83-21.24-19.83-28.7l6.26-74.4c0-7.46,6.1-13.57,13.57-13.57h14.92c7.46,0,13.57,6.1,13.57,13.57l2.91,74.4c0,7.46-11.73,21.69-16.47,28.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M754.75,414.99h-14.92c-7.46,0-13.57,6.1-13.57,13.57l-5.44,66c16.76,5.33,39.38-5.51,49.39-17.45l-1.9-48.55c0-7.46-6.1-13.57-13.57-13.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M696.08,508.38l23.92,44.22s12.81-10.53,14.05-8.47c1.24,2.07-2.27,28.13-2.27,28.13,0,0,28.5.39,29.74-.85,1.24-1.24-5.78-28.31-2.89-28.31s11.59,7.85,11.59,7.85l26.71-42.57-5.87-1.43-43.76,23.55-46.81-23.03-4.4.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "723.43 528.76 741.2 540.68 735.7 572.32 759.66 570.98 753.67 542.2 768.4 528.76 761.48 522.24 730.35 522.24 723.43 528.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M721.24,486.71l-21.97,20.91s22.39,39.82,23.63,39.82,19-21.95,19-21.95l11.37-.2,17.96,18.85,20.87-36.92-21.29-22.56s-18.18,35.11-21.48,35.94c-3.3.83-3.33,1.24-6-.83-2.67-2.07-22.09-33.05-22.09-33.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 747.29,
    cy: 415.74,
    rx: 45.11,
    ry: 61.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M706.8,414.79c4.22,8.88,2.84,18.36-3.08,21.18-5.92,2.81-14.14-2.11-18.36-10.99-4.22-8.88-2.84-18.36,3.08-21.18,5.92-2.81,14.14,2.11,18.36,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M785.74,414.79c-4.22,8.88-2.84,18.36,3.08,21.18,5.92,2.81,14.14-2.11,18.36-10.99,4.22-8.88,2.84-18.36-3.08-21.18-5.92-2.81-14.14,2.11-18.36,10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M767.3,440.96s-8.96,14.51-20.01,14.51-20.01-14.51-20.01-14.51h40.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M720.82,373.93c18.59-13.01,26.95-10.84,40.9,10.53,13.94,21.38,30.67,21.75,30.67,21.75l2.17-22.17s-20.77-40.17-48.65-34.91c-27.88,5.27-43.73,30.36-43.73,30.36,0,0-1.36,47.04,2.53,48.64,3.89,1.6,4.34-15.18,7.13-18.59,2.79-3.41-2.79-19.52.93-26.95,3.72-7.44,8.06-8.67,8.06-8.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M780.62,398.1c6.49,7.11,4.03,35.32,7.44,35.01s4.65-26.95,3.72-29.74c-.93-2.79-11.15-5.27-11.15-5.27Z"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1016.5 174.7 1045.41 191.4 1045.41 158.01 1016.5 174.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "396.52 174.7 425.44 191.4 425.44 158.01 396.52 174.7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "442.08 845.43 413.16 828.74 413.16 862.13 442.08 845.43"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1050.23 845.43 1021.32 828.74 1021.32 862.13 1050.23 845.43"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1307.61 700.24 1290.91 729.15 1324.3 729.15 1307.61 700.24"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1307.61 292.03 1290.91 320.94 1324.3 320.94 1307.61 292.03"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "208.77 361.76 225.46 332.85 192.07 332.85 208.77 361.76"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "208.77 753.91 225.46 725 192.07 725 208.77 753.91"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1307.64,
    cy: 513.4,
    r: 6.38,
    transform: "translate(332.66 1524.79) rotate(-67.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1318.7,536.26c0-6.11-4.97-11.07-11.07-11.07s-11.07,4.97-11.07,11.07v6.44c3.36,1.61,7.11,2.51,11.07,2.51s7.72-.9,11.07-2.51v-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1307.62,493.79c-14.18,0-25.71,11.53-25.71,25.71,0,7.91,3.59,14.99,9.23,19.71v-2.96c0-6.14,3.37-11.5,8.36-14.34-2.25-2.15-3.66-5.17-3.66-8.52,0-6.5,5.29-11.79,11.79-11.79s11.79,5.29,11.79,11.79c0,3.35-1.41,6.38-3.66,8.52,4.99,2.84,8.36,8.2,8.36,14.34v2.96c5.64-4.72,9.23-11.81,9.23-19.71,0-14.18-11.53-25.71-25.71-25.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1348.38,509.58c-1.02-4.2-2.67-8.18-4.93-11.88l2.71-4.94-11.81-11.8-4.94,2.71c-3.7-2.26-7.68-3.91-11.88-4.93l-1.57-5.41h-16.69l-1.57,5.41c-4.2,1.02-8.18,2.67-11.88,4.93l-4.94-2.71-11.81,11.81,2.71,4.94c-2.26,3.7-3.91,7.68-4.93,11.88l-5.41,1.57v16.69l5.41,1.57c1.02,4.2,2.67,8.18,4.93,11.88l-2.71,4.94,11.81,11.81,4.94-2.71c3.7,2.26,7.68,3.91,11.88,4.93l1.57,5.41h16.69l1.57-5.41c4.2-1.02,8.18-2.67,11.88-4.93l4.94,2.71,11.81-11.81-2.71-4.94c2.26-3.7,3.91-7.68,4.93-11.88l5.41-1.57v-16.69l-5.41-1.57ZM1307.62,550.62c-17.16,0-31.12-13.96-31.12-31.12s13.96-31.12,31.12-31.12,31.12,13.96,31.12,31.12-13.96,31.12-31.12,31.12h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.94467cae1dd2e9c3b99054e43bd247bd.svg";
export { ForwardRef as ReactComponent };